
import CartBody from "@/components/cart/CartBody.vue";
import CartResume from "@/components/cart/CartResume.vue";
import { Component, Vue } from "vue-property-decorator";
import { StorageElements } from "@/models/entities/storage/storageElements.interface";
import { getModule } from "vuex-module-decorators";
import StorageCartModule from "@/store/modules/storage/storageCart.module";
import OverlayModule from "@/store/modules/core/overlay.module";
import SnackbarModule from "@/store/modules/core/snackbar.module";
import { cartService } from "@/services/api/cart.service";
import { StorageRowInsert } from "@/models/entities/storage/storageInput/storageRowInsert.interface";
import { RequireKitResponse } from "@/models/entities/storage/cart/cartKit.interface";
import store from "@/store";
const storageModule = getModule(StorageCartModule, store);
const overlayModule = getModule(OverlayModule, store);
const snackbarModule = getModule(SnackbarModule, store);
const AppBar = () =>
  import(/* webpackChunkName: "AppBar" */ "@/components/core/AppBar.vue");
const AppFooter = () => import("@/components/core/AppFooter.vue");

@Component({
  components: {
    AppBar,
    AppFooter,
    CartBody,
    CartResume,
  },
})
export default class Cart extends Vue {
  private elementsList: StorageElements[] = [];
  private insertArray: StorageRowInsert[] = [];
  private responseKit: RequireKitResponse = null;
  private elementCount = 0;
  mounted(): void {
    try {
      this.updateSelected();
      this.updateElements();
      if (this.elementCount > 0) this.requireKit();
    } catch (e) {
      console.warn(e);
    }
  }

  private changeKit(kit: RequireKitResponse): void {
    this.responseKit.addToTotalNoVat = kit.addToTotalNoVat;
    this.responseKit.kitNumber = kit.kitNumber;
    this.responseKit.requireKit = kit.requireKit;
  }

  private requireKit(): void {
    let array: Array<string[]> = [];
    this.elementsList.forEach((el) => {
      array.push([el.art_Codice, el.qtySelected.toString()]);
    });
    cartService.requireKit(array).then((res) => {
      this.responseKit = res.data;
    });
  }

  private updateSelected(): void {
    this.elementCount = storageModule.count;
  }

  private updateElements(): void {
    this.elementsList = storageModule.cart;
  }

  get totalItems(): number {
    let sum = 0;
    this.elementsList.forEach((element) => {
      sum = sum + parseInt(element.qtySelected.toString());
    });
    return sum;
  }

  get totalItemsWithoutTax(): number {
    let sum = 0;

    this.elementsList.forEach((element) => {
      if (
        element.qtySelected < 4 ||
        element.sconto4Pezzi == null ||
        element.sconto4Pezzi == 0.0
      ) {
        sum += Number(
          (
            parseFloat(element.nettO_SCONTATO.toFixed(2)) * element.qtySelected
          ).toFixed(2)
        );
      } else {
        sum += Number(
          (
            parseFloat(element.nettO4PEZZI.toFixed(2)) * element.qtySelected
          ).toFixed(2)
        );
      }
      // sum =
      //   sum +
      //   parseFloat(element.nettO_SCONTATO.toString()) *
      //     parseInt(element.qtySelected.toString());
    });

    if (this.responseKit != null) {
      if (this.responseKit.requireKit) {
        sum = sum + parseFloat(this.responseKit.addToTotalNoVat.toString());
      }
    }

    return sum;
    //spedizione -> modificare
  }

  get totalItemsWithTax(): number {
    return this.totalItemsWithoutTax + (this.totalItemsWithoutTax * 22) / 100;
  }

  private addQty(element: StorageElements): void {
    let value = parseInt(element.qtySelected.toString());
    value += 1;
    element.qtySelected = value;
    if (element.art_Categoria == "002") {
      this.requireKit();
    }
  }

  private checkQty(element: StorageElements): void {
    if (element.qtySelected < 1) element.qtySelected = 1;
  }

  private removeQty(element: StorageElements): void {
    if (element.qtySelected > 1) element.qtySelected -= 1;
    if (element.art_Categoria == "002") {
      this.requireKit();
    }
  }

  private removeAll(): void {
    try {
      storageModule.removeAllFromCart();
      this.updateSelected();
      this.updateElements();
    } catch (e) {
      console.warn(e);
    }
  }

  private removeElement(element): void {
    try {
      storageModule.removeFromCart(element);
      this.updateSelected();
      this.updateElements();
    } catch (e) {
      console.warn(e);
    }
  }

  private orderConfirm(notes: string): void {
    //inserisco tutti i valori e confermo ordine
    overlayModule.showOverlay();
    this.updateElements();
    this.insertArray = [];
    this.elementsList.forEach((element) => {
      const newElement: StorageRowInsert = {
        orderID: "-1",
        productID: element.art_Codice,
        modelDescription: element.art_Descr,
        catalogueSource:
          element.catalogueSource != null ? element.catalogueSource : 1,
        tireDimension: "", //
        theRim: String(element.art_Diametro), //
        category: element.category, //
        height: element.height, //
        canaleWidth:
          element.art_Canale != null ? element.art_Canale.toString() : "",
        itemID: element.itemID,
        qty: element.qtySelected != null ? element.qtySelected.toString() : "",
        netto4Pezzi:
          element.nettO4PEZZI != null && element.nettO4PEZZI != 0
            ? element.nettO4PEZZI.toString()
            : element.sconto != null && element.sconto != 0
            ? element.nettO_SCONTATO.toString()
            : element.prezzO_NETTO.toString(),
        nettoScontato:
          element.nettO_SCONTATO != null
            ? element.nettO_SCONTATO.toString()
            : "",
        prezzoNetto:
          element.prezzO_NETTO != null ? element.prezzO_NETTO.toString() : "",
        keywords: element.keywords,
        brand: element.brand,
        model: element.store,
        carType: element.type,
        fromYear: element.year,
      };
      this.insertArray.push(newElement);
    });
    const result = cartService.addOrder(
      this.insertArray,
      notes,
      this.responseKit != null ? this.responseKit.requireKit : false,
      this.responseKit != null
        ? this.responseKit.kitNumber != null
          ? this.responseKit.kitNumber.toString()
          : "0"
        : "0"
    );
    result.then((x) => {
      if (x.data.isSuccess) {
        this.insertArray = [];
        this.removeAll();
        snackbarModule.showSnackbar({
          message: "Ordine inserito correttamente!",
          type: "success",
        });
        setTimeout(() => snackbarModule.hideSnackbar(), 5000);
      } else {
        snackbarModule.showSnackbar({
          message:
            "Si è verificato un errore durante la creazione dell'ordine!",
          type: "error",
        });
        setTimeout(() => snackbarModule.hideSnackbar(), 5000);
      }
      overlayModule.hideOverlay();
    });
  }
}
